import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/site/Marquee";
import { DestinosBento } from "../components/home/DestinosBento";
import { Features } from "../components/home/Features";
import { Tarifas } from "../components/home/Tarifas";
import { PuntoEnvioTeaser } from "../components/home/PuntoEnvioTeaser";
import { FinalCta } from "../components/home/FinalCta";
import { Flota } from "../components/home/Flota";
import { PromosHome } from "../components/home/PromosHome";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <PromosHome />
      <DestinosBento />
      <Features />
      <Flota />
      <Tarifas />
      <PuntoEnvioTeaser />
      <FinalCta />
    </>
  );
}
